import React, { useEffect, useState } from "react";
import { Redirect, Route } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getProfileDetail } from "../../Actions/ProfileAction";
import HeaderSidebar from "../CommonComponent/HeaderSidebar";
import { Paths } from "./routePaths";

const EntrepreneurAdminRoute = (props) => {
  const { component: Component, ...rest } = props;
  const token = sessionStorage.getItem("ssoToken");
  const userRole = sessionStorage.getItem("userRole");
  const [isDarkMode] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (token) {
      dispatch(getProfileDetail());
    }
  }, [dispatch, token]);

  if (!token) {
    return <Redirect to={Paths.EntrepreneurAdminLogin} />;
  }

  if (userRole !== "entrepreneur_admin") {
    if (userRole === "super_admin") {
      return <Redirect to={Paths.Admin} />;
    }
    if (userRole === "udc_admin" || userRole === "prolific_admin") {
      return <Redirect to="/org-dashboard" />;
    }
    if (userRole === "entrepreneur") {
      return <Redirect to="/entrepreneur/introduction" />;
    }
    return <Redirect to={Paths.upgradeDashboard} />;
  }

  return (
    <>
      <HeaderSidebar />
      <Route
        {...rest}
        render={(routeProps) => (
          <Component {...routeProps} isDarkMode={isDarkMode} />
        )}
      />
    </>
  );
};

export default EntrepreneurAdminRoute;
